export default __webpack_public_path__ + "static/careers_mobile-0f54284846a1903a75b43d09ad60288f.jpg";